
import { useState, useEffect, useRef } from 'react';
import { useCountAnimation } from '../../hooks/useCountAnimation';

interface AnimatedCounterProps {
  end: number;
  suffix?: string;
  duration?: number;
  className?: string;
}

export default function AnimatedCounter({ 
  end, 
  suffix = '', 
  duration = 2000, 
  className = '' 
}: AnimatedCounterProps) {
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef<HTMLDivElement>(null);
  const count = useCountAnimation({ end, duration, startAnimation: isVisible });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { 
        threshold: 0.3,
        rootMargin: '50px'
      }
    );

    const currentRef = counterRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const formatNumber = (num: number) => {
    if (suffix === '%') {
      return num;
    }
    return num.toLocaleString('tr-TR');
  };

  return (
    <div ref={counterRef} className={className}>
      {formatNumber(count)}{suffix}
    </div>
  );
}